import { Pipe, PipeTransform } from '@angular/core';
import { IDropdownOption } from 'scw-digital-boards-widgets';

@Pipe({
  name: 'filterAvailableFields',
  standalone: true,
})
export class FilterAvailableFieldsPipe implements PipeTransform {
  public transform(
    allOptions: IDropdownOption<string>[],
    configurationsValue: any[],
    currentIndex: number,
  ): IDropdownOption<string>[] {
    const selectedIds: Set<string> = (configurationsValue as { formField: IDropdownOption<string>[] | null }[]).reduce<
      Set<string>
    >((acc, config, index) => {
      const fieldId: string | undefined = config.formField?.[0]?.id;

      if (index !== currentIndex && fieldId) {
        acc.add(fieldId);
      }

      return acc;
    }, new Set<string>());

    return allOptions.filter((option) => !selectedIds.has(option.id));
  }
}
